import { BookmarkModel } from 'src/app/bookmarks/models/bookmark.model';

export class CollectionModel {
    collection_createdate: Date;
    collection_desc: string;
    collection_name: string;
    collection_updatedate: Date;
    collection_id: number;
    group_id: number;
    collection_content: BookmarkModel[];
}
